import React from 'react';
import { LayoutDashboard, Building2, Users, CreditCard, FileBarChart, ScrollText, LogOut, Menu, X } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
interface SidebarProps {
  isOpen: boolean;
  toggleSidebar: () => void;
  currentPage: string;
  onNavigate: (page: string) => void;
}
export function Sidebar({
  isOpen,
  toggleSidebar,
  currentPage,
  onNavigate
}: SidebarProps) {
  const {
    isAdmin,
    isBranch,
    currentUser,
    logout
  } = useAuth();
  const menuItems = [{
    id: 'dashboard',
    label: 'Dashboard',
    icon: LayoutDashboard,
    allowed: true
  }, {
    id: 'branches',
    label: 'Branches',
    icon: Building2,
    allowed: isAdmin
  }, {
    id: 'users',
    label: 'Users',
    icon: Users,
    allowed: isAdmin
  }, {
    id: 'payments',
    label: 'Payments',
    icon: CreditCard,
    allowed: true
  }, {
    id: 'reports',
    label: 'Reports',
    icon: FileBarChart,
    allowed: true
  }, {
    id: 'audit',
    label: 'Audit Log',
    icon: ScrollText,
    allowed: isAdmin
  }];
  return <>
      {/* Mobile Overlay */}
      {isOpen && <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={toggleSidebar} data-id="element-39" />}

      {/* Sidebar */}
      <aside className={`
        fixed top-0 left-0 z-50 h-screen w-64 bg-[#1B6B3A] text-white transition-transform duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `} data-id="element-40">
        {/* Header */}
        <div className="h-20 flex items-center justify-between px-4 border-b border-[#145A2E]" data-id="element-41">
          <div className="flex items-center space-x-3" data-id="element-42">
            <img src="https://cdn.magicpatterns.com/uploads/tWYmSpJz5EKRVmEj9X8aaH/CDNS.jpg" alt="CDNS Logo" className="w-11 h-11 rounded-md object-cover bg-white p-0.5" data-id="element-43" />
            <div className="flex flex-col" data-id="element-44">
              <span className="text-lg font-bold tracking-wide leading-tight" data-id="element-45">
                National
              </span>
              <span className="text-lg font-bold tracking-wide leading-tight" data-id="element-46">
                Savings
              </span>
            </div>
          </div>
          <button onClick={toggleSidebar} className="lg:hidden text-white" data-id="element-47">
            <X className="w-6 h-6" data-id="element-48" />
          </button>
        </div>

        {/* Navigation */}
        <nav className="p-4 space-y-1 overflow-y-auto h-[calc(100vh-8rem)]" data-id="element-49">
          {menuItems.filter(item => item.allowed).map(item => <button key={item.id} onClick={() => {
          onNavigate(item.id);
          if (window.innerWidth < 1024) toggleSidebar();
        }} className={`
                w-full flex items-center px-4 py-3 rounded-lg transition-colors
                ${currentPage === item.id ? 'bg-[#D4A017] text-[#1B6B3A] font-semibold shadow-md' : 'text-white hover:bg-[#2D8F4E]'}
              `} data-id="element-50">
                <item.icon className="w-5 h-5 mr-3" data-id="element-51" />
                {item.label}
              </button>)}
        </nav>

        {/* User Info Footer */}
        <div className="absolute bottom-0 left-0 w-full p-4 border-t border-[#145A2E] bg-[#145A2E]" data-id="element-52">
          <div className="flex items-center space-x-3" data-id="element-53">
            <div className="w-10 h-10 rounded-full bg-[#D4A017] flex items-center justify-center text-[#1B6B3A] font-bold" data-id="element-54">
              {currentUser?.fullName.charAt(0)}
            </div>
            <div className="flex-1 min-w-0" data-id="element-55">
              <p className="text-sm font-medium truncate" data-id="element-56">
                {currentUser?.fullName}
              </p>
              <p className="text-xs text-green-200 truncate" data-id="element-57">
                {currentUser?.role}
              </p>
            </div>
            <button onClick={logout} className="text-green-200 hover:text-white transition-colors" title="Logout" data-id="element-58">
              <LogOut className="w-5 h-5" data-id="element-59" />
            </button>
          </div>
        </div>
      </aside>
    </>;
}